import { render, staticRenderFns } from "./PaymentSummary.vue?vue&type=template&id=71368580&"
import script from "./PaymentSummary.vue?vue&type=script&lang=js&"
export * from "./PaymentSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports